import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import BecomeAgentBanner from './become-agent-banner';
import BecomeAgentDescription from './become-agent-description';
import BecomeAgentForm from './become-agent-form'; 


function BecomeAgentPage () {
    return(
      <Fragment> 
      <Header />  
      <BecomeAgentBanner /> 
      <BecomeAgentDescription /> 
      <BecomeAgentForm />
      <Footer /> 
      </Fragment> 
    );
}
export default BecomeAgentPage;